
import { defineComponent, computed } from 'vue'
import store from '@/store'
import BaseTable from '@/components/Shared/BaseTable.vue'
import { useFeatureAccess } from '@/composables/useFeatureAccess'

export default defineComponent({
  components: {
    BaseTable
  },
  emits: ['delete'],
  setup() {
    const images = computed(() => store.state.images.images)
    const { canManage: canDeleteImages } = useFeatureAccess('image')
    return { images, canDeleteImages }
  }
})
